import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { getAiPlanContentQueryFn } from './queries/get-ai-plan-content.query';
export const AiContentQueriesConfig = createQueriesConfig({
  getAiPlanContent: {
    queryFn: getAiPlanContentQueryFn
  }
});
//# sourceMappingURL=ai-content.queries.js.map